<div
  [formGroup]="formGroup"
  class="reservation-service-tile-form-container"
  [ngClass]="{ 'row-spacing': useSpacing }"
>
  <ng-container
    formArrayName="serviceFormArray"
    *ngFor="let service of serviceFormArray.controls; index as i"
  >
    <div [formGroupName]="i" class="row pt-2 pb-2 no-gutters add-on-row">
      <div class="col-auto mr-2">
        <mat-checkbox
          [checked]="service.value.isSelected"
          [disabled]="!canBeSelectable(i)"
          (change)="toggleService(i)"
          (keyup.enter)="toggleService(i)"
        ></mat-checkbox>
      </div>
      <div class="col-11 service-info-table">
        <div class="row no-gutters clickable" (click)="toggleService(i)">
          <div
            class="lato primary mt-1 col-10"
            [ngClass]="{ 'disabled-text': false }"
          >
            <span>{{ service.value.name }}</span>
            <span *ngIf="service.value?.description"
              class="service-description">{{ service.value.description }}</span>
          </div>
          <div class="service-info-table col-1">
            <div class="reservation-service-price oswald">
              {{ service.value.price | currency }}
            </div>
          </div>
        </div>
        <div
          *ngIf="service.value.isSelected && service.value.displayQuantityInput"
          class="row no-gutters"
        >
          <div class="col-11">
            <div class="input-container">
              <span class="input-label">Quantity</span>
              <input
                aria-label="quantity"
                type="number"
                min="1"
                max="99"
                class="input"
                formControlName="quantity"
                (change)="changeQuantity($event, i)"
                (keyup)="changeQuantity($event, i)"
              />
              <span
                class="res-error"
                *ngIf="
                  service.value.isSelected && inputErrorMessages[i] !== ''
                "
              >
                <img
                  src="../../../../../assets/svg/ico_error_circle.svg"
                  alt="Error icon"
                  width="12"
                />
                {{ inputErrorMessages[i] }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
